import React from 'react'
import ReactSelect from 'react-select'
import ReactCreatableSelect from 'react-select/creatable'
import cx from 'classnames'
import { t } from 'ttag'

import { ClearIndicator } from './../ClearIndicator/ClearIndicator'
import { DropdownIndicator } from './../DropdownIndicator/DropdownIndicator'

import styles from './../../Combobox.module.scss'

export const Select = React.forwardRef(
  (
    {
      error,
      id,
      name,
      noOptionsMessage = t`There're no options to choose`,
      options,
      placeholder,
      value,
      onBlur,
      onChange,
      filterOption,
      closeMenuOnSelect = true,
      isClearable = true,
      isCreatable = false,
      isDisabled = false,
      isMulti = false,
      isReadOnly = false,
      isRequired = false,
      isSearchable = false,
    },
    ref,
  ) => {
    const SelectComponent = isCreatable ? ReactCreatableSelect : ReactSelect

    return (
      <SelectComponent
        className={styles.combobox}
        classNames={{
          control: ({ isFocused }) =>
            cx(styles.control, {
              [styles.focus]: isFocused,
              [styles.disabled]: isDisabled,
              [styles.readOnly]: isReadOnly,
              [styles.invalid]: Boolean(error),
            }),
          input: () => styles.input,
          multiValue: () => styles.multiValue,
          placeholder: () => styles.placeholder,
          singleValue: () => styles.singleValue,
          multiValueRemove: () => styles.multiValueRemove,
          valueContainer: ({ isMulti, hasValue }) =>
            cx(styles.valueContainer, {
              [styles.multi]: isMulti && hasValue,
            }),
          menu: () => styles.menu,
          menuList: () => styles.menuList,
          option: ({ isSelected }) =>
            cx(styles.option, { [styles.selected]: isSelected }),
          noOptionsMessage: () => styles.noOptionsMessage,
        }}
        components={{
          ClearIndicator: ({ innerProps: { ref, ...props } }) => (
            <ClearIndicator {...{ ref, ...props }} />
          ),
          MultiValueRemove: ({ innerProps: { ref, ...props } }) => (
            <ClearIndicator {...{ ref, ...props }} />
          ),
          DropdownIndicator: () => <DropdownIndicator />,
          IndicatorSeparator: () => null,
        }}
        required={isRequired}
        isClearable={isReadOnly ? false : isClearable}
        isSearchable={isReadOnly ? false : isSearchable}
        menuIsOpen={isReadOnly ? false : undefined}
        {...{
          inputId: id,
          name,
          options,
          noOptionsMessage: () => noOptionsMessage,
          placeholder,
          closeMenuOnSelect,
          ref,
          value,
          onBlur,
          filterOption,
          onChange,
          isDisabled,
          isMulti,
        }}
      />
    )
  },
)
